import React, {FunctionComponent} from "react"
import Button from "@murphy-frontend/web-core/components/Button"

interface EditsRowProps {
	enableEdit: boolean
	description: string
	handleTextChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
	onCancel: () => void
	onSave: () => void
	isLoading: boolean
}

const EditRow: FunctionComponent<EditsRowProps> = ({
	enableEdit,
	description,
	handleTextChange,
	onCancel,
	onSave,
	isLoading
}) => {
	return (
		<>
			{enableEdit && (
				<div className='actions-edit-wrapper'>
					<textarea
						className='actions-row-textarea'
						value={description}
						disabled={false}
						onChange={handleTextChange}
						rows={1}
					/>
					<div className='actions-row-edit-btn'>
						<Button
							onClick={onSave}
							isLoading={isLoading}
							buttonSize={"btn--medium"}
							isNeutralButton={true}
						>
							Save
						</Button>
						<Button onClick={onCancel} buttonSize={"btn--medium"} isLightButton={true}>
							Cancel
						</Button>
					</div>
				</div>
			)}
		</>
	)
}

export default EditRow
